module.exports = __webpack_public_path__ + "static/media/menu_icon_03.5f8f2f34.svg";